export default "__VITE_ASSET__1Vi76f$A__"